'use strict';

/**
* @ngdoc controller
* @name tcApp.controllers:FloorplanCtrl
* @description
* Floorplan controller.
*
*/

angular.module('tcApp')
.value('fpData', null)
.controller('FloorplanCtrl', function($scope, $window, $log, $location, $rootScope, $timeout, $interval,
									$mdSidenav, fpData, GlobalService, WorkflowService, SystemRouter,
									IconProfileService, tcConstants) {
	var onInit = function(fpData) {
		if (fpData != null) {
			$scope.data = fpData.data;
		}
		if (angular.isUndefined($scope.data)) $scope.data = {};
		$scope.globalStrings = GlobalService.getGlobalStrings();
		$scope.viewModel = {
			selectedBedIndex: null,
			selectedRoomIndex: null,
			selectedRoomPatientIndex: null,
			selectedResourceIndex: null,
			refreshDataPromise: null,
			showLinkedLocations: false,
			allowLayoutPicker: isLayoutEditingAllowed(),
			hasMessageChecks: false,
			menuMessageConfirmed: true,
		};
		$scope.componentHtmlName = 'tc_Floorplan';
		if (angular.isArray($scope.data.similarNamePatients) && ($scope.data.similarNamePatients.length)) {
			$scope.viewModel.hasMessageChecks = true;
		}
		
		if ((angular.isDefined($scope.data.configuration))
			&& (angular.isDefined($scope.data.configuration.refreshTime))
			&& ($scope.data.configuration.refreshTime > 0)) {
			var refreshData = function() {
				SystemRouter.fetchFloorplanData($scope.data.wardId, '', '', '', '', $scope.data.headerComponent.data.items.TWKFL.value,
												$scope.data.headerComponent.data.items.TWKFLI.value,
												$scope.data.headerComponent.data.componentContext)
				.then(function(response) {
					if (response.data.error) $log.error(response.data.error);
					deselectPatient();
					// Reset all data so one-time bindings still work
					$scope.data = {};
					$timeout(function setDataOnRefresh() {
						$scope.data = response.data;
						getAllIconProfileData();
					});
					// Re-run the component script for the floorplan header
					$timeout(function runFloorplanHeaderScript() {
						$scope.$broadcast('Component:initialise', $scope.data.headerComponent.name, {
							componentName: $scope.data.headerComponent.name,
							data: $scope.data.headerComponent.data
						});
					}, 200);
				});
			};
			$scope.viewModel.refreshDataPromise = $interval(refreshData, ($scope.data.configuration.refreshTime * 1000 * 60), 0);
		}
		
		$timeout(getAllIconProfileData); // $timeout to unblock template calls
		
	};
	
	var getAllIconProfileData = function(roomId) {
		var iconProfilePromises = [];
		if (angular.isUndefined(roomId)) {
			angular.forEach($scope.data.beds, function(bed) {
				if (angular.isDefined(bed.patient)) {
					angular.forEach(bed.patient.dataRows, function(dataArray) {
						angular.forEach(dataArray, function(dataItem) {
							if (angular.isDefined(dataItem.iconProfileId) && (dataItem.iconProfileId != '')) {
								iconProfilePromises.push(getIconProfileData(bed.patient, 'ARY', dataItem));
							}
						});
					});
				}
			});
			angular.forEach($scope.data.resources, function(resource) {
				if (angular.isDefined(resource.patient)) {
					angular.forEach(resource.patient.dataRows, function(dataArray) {
						angular.forEach(dataArray, function(dataItem) {
							if (angular.isDefined(dataItem.iconProfileId) && (dataItem.iconProfileId != '')) {
								iconProfilePromises.push(getIconProfileData(resource.patient, 'ARY', dataItem));
							}
						});
					});
				}
			});
		}
		angular.forEach($scope.data.rooms, function(room) {
			// For room paging, only retrieve the icons for that room
			if (angular.isDefined(room.id) && angular.isDefined(room.patients)) {
				angular.forEach(room.patients, function(patient) {
					angular.forEach(patient.dataRows, function(dataArray) {
						angular.forEach(dataArray, function(dataItem) {				
							if (angular.isDefined(dataItem.iconProfileId) && (dataItem.iconProfileId != '')) {
								iconProfilePromises.push(getIconProfileData(patient, ('ARYROOM' + room.id), dataItem));
							}
						});
					});
				});
			}
		});
	};
	
	var getIconProfileData = function(patient, arrayNode, dataItem) {
		var iconProfileId = '';
		if ((angular.isUndefined(patient.iconProfileId)) && (angular.isUndefined(dataItem.iconProfileId))) return;
		if (angular.isUndefined(patient.id)) return;
		if (angular.isUndefined(patient.episodeId)) return;
		if (angular.isDefined(dataItem.iconProfileId)) iconProfileId = dataItem.iconProfileId;
		if (iconProfileId === '') {
			if (angular.isDefined(patient.iconProfileId)) iconProfileId = patient.iconProfileId;
		}
		if (iconProfileId === '') return;
		if (patient.episodeId === '') return;
		
		var iconProfileValue = IconProfileService.buildIconProfileValue({
			'EpisodeID': patient.episodeId,
			'PatientID': patient.id,
			'ApptID': patient.apptId,
			'WardID': $scope.data.wardId,
			'OperRoomID': patient.operRoomId
		});
		
		IconProfileService.getIconProfileData(iconProfileId, iconProfileValue, dataItem, 'epr.floorplan', arrayNode,
								$scope.data.floorplanComponent.data.componentContext);
		
		// include headers for the iconProfile panel
		if (angular.isArray(patient.actionMenuDataHeaders) && (patient.actionMenuDataHeaders.length > 0)) {
			dataItem.dataHeaders = patient.actionMenuDataHeaders;
		} else if (angular.isArray(patient.dataHeaders)) {
			dataItem.dataHeaders = patient.dataHeaders;
		}
		if ($scope.viewModel.hasMessageChecks) {
			dataItem.tcSelectMessageFunc = $scope.getSelectRowMessage;
			dataItem.tcSelectMessageObject = {id: patient.id};
		}
	};

	if ($scope.data.bannerData) GlobalService.updateBannerData($scope.data.bannerData);
	if ($scope.data.counters) GlobalService.updateCounters($scope.data.counters);

	$scope.actionMenuHandler = function($event, patient, bedOrRoom, bedOrRoomIndex, roomPatientIndex) {
		$event.stopPropagation();
		
		// Select the patient when opening their action menu
		if (angular.isDefined(roomPatientIndex)) {
			if (!patient.selected) {
				$scope.selectRoomPatient($event, bedOrRoom, bedOrRoomIndex, patient, roomPatientIndex, true);
			}
		} else if (!bedOrRoom.selected) {
			$scope.selectBed($event, bedOrRoom, bedOrRoomIndex, true); 
		}
		
		var patientData = {
			'PatientID': patient.id,
			'EpisodeID': patient.episodeId,
			'apptID': patient.apptId,
			'OperRoomID': patient.operRoomId,
			'_passParameters': patient['_passParameters'],
			'_passParametersRaw': patient['_passParametersRaw'],
			'_actionHeaders': patient['actionMenuDataHeaders'],
			'_actionItems': patient['actionMenuDataItems']
		};

		var rowIndex = 0;
		var actionMenuData = {
			componentHtmlName: $scope.data.floorplanComponent.data.componentHtmlName,
			listRow: patientData,
			translations: $scope.data.translations,
			rowIndex: rowIndex,
			triggeringElement: $event.currentTarget
		};
		var messageItem = $scope.getSelectRowMessage(patient);
		if (messageItem) {
			actionMenuData.messages = [messageItem];
			actionMenuData.messageCallbackFunc = $scope.confirmMenuMessage;
		}
		$mdSidenav('actionMenu').open().then(function actionMenuOpenHandler() {
			GlobalService.onModalToggle(true);
			//messageType conditional is currently redundant as there is currently only one 'W' message used on floorplan
			// but structure is there for future message changes
			if ((messageItem) && ((messageItem.messageType === tcConstants.COMPONENT_MESSAGE_TYPE.WARNING)
					|| (messageItem.messageType === tcConstants.COMPONENT_MESSAGE_TYPE.ERROR))) {
				$scope.viewModel.menuMessageConfirmed = false;
			}
			$rootScope.$broadcast('System:focusActionMenu');
		});
		$mdSidenav('actionMenu').onClose(function actionMenuCloseHandler() {
			if (!$scope.viewModel.menuMessageConfirmed) deselectPatient();
			$scope.viewModel.menuMessageConfirmed = true;
			$mdSidenav('actionMenu').onClose(angular.noop);
		});
		
		$rootScope.$broadcast('System:updateActionMenu', actionMenuData);
	};
	/// callback function from the actionMenu message buttons
	$scope.confirmMenuMessage = function(confirmed) {
		$scope.viewModel.menuMessageConfirmed = confirmed;
	};
	
	var isSimilarNamePatient = function(patient) {
		if (angular.isUndefined(patient.id)) return false;
		if (angular.isDefined(patient.hasSimilarName)) return patient.hasSimilarName;
		if (angular.isArray($scope.data.similarNamePatients)) {
			patient.hasSimilarName = ($scope.data.similarNamePatients.indexOf(patient.id) !== -1);
		} else {
			patient.hasSimilarName = false;
		}
		return (patient.hasSimilarName);
	};
	/// setup any messaging for patient selection
	$scope.getSelectRowMessage = function(patient) {
		if (!$scope.viewModel.hasMessageChecks) return null;
		// add similar name patient checks
		if (isSimilarNamePatient(patient)) {
			var message = {
				messageType: tcConstants.COMPONENT_MESSAGE_TYPE.WARNING,
				messageText: $scope.data.translations['PtSimilarName'],
			};
			return message;
		}
		return null;
	};
	/// process any messages upon selection 
	var actionSelectRowMessage = function(patient) {
		var messageItem = $scope.getSelectRowMessage(patient);
		if (angular.isObject(messageItem)) {
			if (messageItem.messageType === tcConstants.COMPONENT_MESSAGE_TYPE.WARNING) {
				return $window.confirm(messageItem.messageText);
			} else {
				$window.alert(messageItem.messageText);
				if (messageItem.messageType === tcConstants.COMPONENT_MESSAGE_TYPE.ERROR) return false;
			}
		}
		return true;
	};
	
	$scope.bedStatusHandler = function($event, bed, bedIndex) {
		$event.stopPropagation();
		if ($scope.data.configuration.isDisplayOnly) return;
		
		var selectedPatient = getSelectedPatient();
		if (($scope.viewModel.selectedBedIndex !== null) && (bed.occupied) && (!bed.patient.isVIP)) {
			if ((selectedPatient) && (selectedPatient.isMovable)) {
				var swapUrl = WorkflowService.getNextLevelUrl(bed.swapUrl
				+ '&OrigBedID=' + $scope.data.beds[$scope.viewModel.selectedBedIndex].id
				+ '&OrigEpisodeID=' + selectedPatient.episodeId
				+ '&OrigPatientID=' + selectedPatient.id);
				$location.url(swapUrl);
				return;
			}
		} else if (selectedPatient) {
			// Default to move if a patient is selected
			$scope.selectBed($event, bed, bedIndex);
		} else if ((!selectedPatient) && (!bed.isResource)) {
			var statusUrl = WorkflowService.getNextLevelUrl(bed.statusUrl);
			$location.url(statusUrl);
		}
	};

	// De-select any currently selected patient in a bed or room
	var deselectPatient = function() {
		if ($scope.viewModel.selectedBedIndex !== null) {
			$scope.data.beds[$scope.viewModel.selectedBedIndex].selected = false;
			$scope.viewModel.selectedBedIndex = null;
		}
		if ($scope.viewModel.selectedResourceIndex !== null) {
			$scope.data.resources[$scope.viewModel.selectedResourceIndex].selected = false;
			$scope.viewModel.selectedResourceIndex = null;
		}
		if (($scope.viewModel.selectedRoomIndex !== null) &&
			($scope.viewModel.selectedRoomPatientIndex !== null)) {
			
			$scope.data.rooms[$scope.viewModel.selectedRoomIndex].
			patients[$scope.viewModel.selectedRoomPatientIndex].selected = false;
			
			$scope.viewModel.selectedRoomIndex = null;
			$scope.viewModel.selectedRoomPatientIndex = null;
		}
	};
	
	// Return the selected patient in a bed or room
	var getSelectedPatient = function() {
		var patient;
		if ($scope.viewModel.selectedBedIndex !== null) {
			patient = $scope.data.beds[$scope.viewModel.selectedBedIndex].patient;
			// Always allow patients in beds to be moved
			patient.isMovable = true;
			return patient;
		} else if ($scope.viewModel.selectedResourceIndex !== null) {
			patient = $scope.data.resources[$scope.viewModel.selectedResourceIndex].patient;
			patient.isMovable = true;
			return patient;
		} else if (($scope.viewModel.selectedRoomIndex !== null) &&
			($scope.viewModel.selectedRoomPatientIndex !== null)) {
			return $scope.data.rooms[$scope.viewModel.selectedRoomIndex].patients[$scope.viewModel.selectedRoomPatientIndex];
		}
		return null;
	};
	
	// Select, deselect or move a patient to a bed
	$scope.selectBed = function($event, bed, bedIndex, isMenuAction) {
		$event.stopPropagation();
		if ($scope.data.configuration.isDisplayOnly) return;
		if ((bed.unavailable) && (!bed.occupied)) return;
		if ((bed.occupied) && (bed.patient.isVIP)) return;
		
		var selectedPatient;
		if (bed.selected) {
			deselectPatient();
		} else if (bed.occupied) {
			deselectPatient();
			bed.selected = true;
			if (bed.isResource) {
				$scope.viewModel.selectedResourceIndex = bedIndex;
				$scope.viewModel.selectedBedIndex = null;
			} else {
				$scope.viewModel.selectedBedIndex = bedIndex;
				$scope.viewModel.selectedResourceIndex = null;
			}
			$scope.viewModel.selectedRoomIndex = null;
			$scope.viewModel.selectedRoomPatientIndex = null;
			
			if (!isMenuAction) {
				selectedPatient = getSelectedPatient();
				if ((selectedPatient) && (!actionSelectRowMessage(selectedPatient))) {
					deselectPatient();
				}
			}
		} else {
			selectedPatient = getSelectedPatient();
			if ((selectedPatient) && (selectedPatient.isMovable)) {
				var moveUrl = $scope.data.moveUrl
				+ '&PARREF=' + selectedPatient.episodeId + '&EpisodeID=' + selectedPatient.episodeId
				+ '&PatientID=' + selectedPatient.id + '&mradm=' + selectedPatient.mradm;
				if (!bed.isResource) {
					moveUrl += '&WardID=' + $scope.data.wardId + '&BedID=' + bed.id;
				}
				var moveUrlExtraParams = checkBedRestrictions(bed, selectedPatient);
				if (moveUrlExtraParams === null) return false;
				moveUrl += moveUrlExtraParams;
				moveUrl = GlobalService.maskUrl(moveUrl);
				moveUrl = WorkflowService.getNextLevelUrl(moveUrl);
				$location.url(moveUrl);
			} else if ((selectedPatient) && (selectedPatient.MoveDisabled)) {
				$window.alert($scope.data.translations['MoveDisabled']);
				return false;
			}
		}
		$scope.refreshNotifications();
	};
	
	// Checks bed restrictions, displays errors/warnings and returns any extra parameters if patient can be moved
	var checkBedRestrictions = function(bed, selectedPatient) {
		var moveUrlExtraParams = '';
		
		if ($scope.data.locType === 'OP') {
			if ($scope.viewModel.selectedResourceIndex !== null) {
				$window.alert($scope.data.translations['OTMoveDisabled']);
				return null;
			}
			// Only allow move to the booked resource
			if (selectedPatient.bookedRescId !== bed.id) {
				$window.alert($scope.data.translations['OTMoveDisabled']);
				return null;
			}
			moveUrlExtraParams += ('&ApptID=' + selectedPatient.apptId + '&apptID=' + selectedPatient.apptId
								+ '&OperRoomID=' + selectedPatient.operRoomId);
			if (($scope.viewModel.selectedRoomIndex !== null)
				&& ($scope.data.rooms[$scope.viewModel.selectedRoomIndex].query === 'OTR')) {
				if ($window.confirm($scope.data.translations['ReverseMove']))	{
					moveUrlExtraParams += '&ReveseMove=1';
				} else {
					return null;
				}
			}
			moveUrlExtraParams += '&OTResource=1';
		}
		
		return moveUrlExtraParams;
	};
	
	// Move a patient to a room
	$scope.selectRoom = function(room, roomIndex) {
		if (angular.isUndefined(room)) return;
		if ($scope.viewModel.selectedRoomIndex === roomIndex) return;
		if (room.query === '') return;
		if (room.inactive) return;
		
		var selectedPatient = getSelectedPatient();
		if ((selectedPatient) && (selectedPatient.isMovable)) {
			var wardId = room.id.split('||')[0];
			var moveUrl = $scope.data.moveUrl
			+ '&PARREF=' + selectedPatient.episodeId + '&EpisodeID=' + selectedPatient.episodeId
			+ '&PatientID=' + selectedPatient.id + '&mradm=' + selectedPatient.mradm + '&WardID=' + wardId
			+ '&RoomID=' + room.id;
			if (($scope.data.locType === 'OP') && (room.locType === 'OP')) {
				moveUrl += '&ToLocation=' + room.locationID;
			}
			var moveUrlExtraParams = checkRoomRestrictions(room, selectedPatient);
			if (moveUrlExtraParams === null) return false;
			moveUrl += moveUrlExtraParams;
			moveUrl = GlobalService.maskUrl(moveUrl);
			moveUrl = WorkflowService.getNextLevelUrl(moveUrl);
			$location.url(moveUrl);
		}
	};
	
	// Checks room restrictions, displays errors/warnings and returns any extra parameters if patient can be moved
	var checkRoomRestrictions = function(room, selectedPatient) {
		var validRoomIdArray = [];
		var moveUrlExtraParams = '';
		if ($scope.data.locType === 'OP') {
			moveUrlExtraParams += ('&ApptID=' + selectedPatient.apptId + '&apptID=' + selectedPatient.apptId
									+ '&OperRoomID=' + selectedPatient.operRoomId);
			if ((room.singlePatient) && (angular.isDefined(room.patients)) && (room.patients.length)) {
				$window.alert($scope.data.translations['CanNotMoveRoom']
								+ '\n' + $scope.data.translations['OTRoomSinglePatientOnly']);
				return null;
			}
			
			var pacRoomId = room.pacRoomId.toString();
			moveUrlExtraParams += ('&RoomDR=' + pacRoomId);
			if (room.query === 'OTWA') {
				if (angular.isDefined(selectedPatient.validOTWaitingRoomIDs)) {
					validRoomIdArray = selectedPatient.validOTWaitingRoomIDs.toString().split(',');
				}
				if (validRoomIdArray.indexOf(pacRoomId) === -1) {
					$window.alert($scope.data.translations['OTRoomMoveDisabled']);
					return null;
				}
				if (($scope.viewModel.selectedRoomIndex === null)
					|| ($scope.data.rooms[$scope.viewModel.selectedRoomIndex].query !== 'OTWA')) {
					if ($window.confirm($scope.data.translations['ReverseMove']))	{
						moveUrlExtraParams += '&ReveseMove=1';
					} else {
						return null;
					}
				}
				moveUrlExtraParams += ('&RBOPWaitingRoomDR=' + pacRoomId);
			} else if (room.query === 'OTR') {
				if (angular.isDefined(selectedPatient.validOTRecoveryRoomIDs)) {
					validRoomIdArray = selectedPatient.validOTRecoveryRoomIDs.toString().split(',');
				}
				if (validRoomIdArray.indexOf(pacRoomId) === -1) {
					$window.alert($scope.data.translations['OTRoomMoveDisabled']);
					return null;
				}
				moveUrlExtraParams += ('&ANARecoveryRoomDR=' + pacRoomId);
			} else if (room.query === 'OTANA') {
				if (($scope.viewModel.selectedRoomIndex === null)
					|| (($scope.data.rooms[$scope.viewModel.selectedRoomIndex].query !== 'OTWA')
						&& ($scope.data.rooms[$scope.viewModel.selectedRoomIndex].query !== 'OTANA'))) {
					if ($window.confirm($scope.data.translations['ReverseMove']))	{
						moveUrlExtraParams += '&ReveseMove=1';
					} else {
						return null;
					}
				}
				moveUrlExtraParams += ('&ANAPreOpRoomDR=' + pacRoomId);
			} else if (room.query === 'OTANAR') {
				moveUrlExtraParams += ('&ANAPreOpAndRecoveryRoomDR=' + pacRoomId);
			}
		}
		
		return moveUrlExtraParams;
	};
	
	// Select or deselect a patient row in a room
	$scope.selectRoomPatient = function($event, room, roomIndex, patient, patientIndex, isMenuAction) {
		$event.stopPropagation();
		if ($scope.data.configuration.isDisplayOnly) return;
		if (patient.isVIP) return;
		if (!patient.isSelectable) return;
		
		if (patient.selected) {
			deselectPatient();
		} else {
			deselectPatient();
			patient.selected = true;
			$scope.viewModel.selectedRoomIndex = roomIndex;
			$scope.viewModel.selectedRoomPatientIndex = patientIndex;
			if (!isMenuAction) {
				if (!actionSelectRowMessage(patient)) {
					deselectPatient();
				}
			}
		}
		$scope.refreshNotifications();
	};
	
	// Fetch data for previous or next page of a room
	$scope.roomPaging = function($event, room, newPageCount, roomIndex) {
		$event.stopPropagation();
		deselectPatient();
		// Pass the correct index based on the paging direction
		var roomPatientIndex = ((newPageCount < room.pageCount) ? room.patientPrevIndex : room.patientIndex);
		
		SystemRouter.fetchFloorplanData($scope.data.wardId, room.id, room.roomIndex, roomPatientIndex, newPageCount)
		.then(function(response) {
			if (response.data.error) {
				$scope.data.error = response.data.error;
				$log.error(response.data.error);
			} else {
				room.patients = response.data.patients;
				room.patientIndex = response.data.patientIndex;
				room.patientPrevIndex = response.data.patientPrevIndex;
				room.pageCount = newPageCount;
				room.moreRows = response.data.moreRows;
				var roomElement = $window.document.getElementById($scope.componentHtmlName + '-room-' + roomIndex);
				if (roomElement) {
					var bodyElement = $window.document.getElementById('tc_Floorplan-misc-body');
					// Browsers scroll on different element ... Chrome vs IE/FF
					if (bodyElement.scrollTop > 0) {
						GlobalService.scrollToElement(roomElement, 0, ($scope.componentHtmlName + '-misc-body'));	
					} else {
						GlobalService.scrollToElement(roomElement, 0, ($scope.componentHtmlName + '-misc-bodyTemplate'));
					}
				}
				$timeout(getAllIconProfileData, 0, true, room.id);
			}
		});
	};
	
	// function to refresh notification count anytime selected patient may change
	$scope.refreshNotifications = function() {
		var PatientID = '';
		var patient = getSelectedPatient();
		if (angular.isObject(patient)) {
			PatientID = patient.id;
		}
		GlobalService.refreshNotifications({'PatientID': PatientID});
	};
	
	$scope.openLayoutPicker = function() {
		var url = ('#/Component/system.Model.Utils.Composite?qComponentName=epr.floorplan&qContext=&WardID='
					+ $scope.data.wardId);
		url = WorkflowService.getNextLevelUrl(url);
		$location.url(url);
	};
	
	$scope.toggleLinkedLocations = function() {
		$scope.viewModel.showLinkedLocations = !$scope.viewModel.showLinkedLocations;
	};
	
	$scope.onViewSelected = function(maskedViewId) {
		if (angular.isUndefined(maskedViewId) || (maskedViewId === '')) return;
		$location.path('/Floorplan/' + $scope.data.maskedWardId + '/' + maskedViewId).replace();
	};
	
	var isLayoutEditingAllowed = function() {
		var logonData = GlobalService.getLogonData();
		if (angular.isUndefined(logonData)) return false;
		if (!logonData.allowDeveloperTools) return false;
		if (angular.isString(logonData.layoutRestrictions)) {
			var layoutRestrictions = logonData.layoutRestrictions.split(',');
			if ((layoutRestrictions.length) && (layoutRestrictions.indexOf('F') === -1)) {
				return false;
			}
		}
		return true;
	};
	
	$scope.$on('Global:userLogon', function(event, sessionData) {
		$scope.globalStrings = sessionData.globalStrings;
	});
	
	$scope.$on('Global:callFunction', function(event, componentHtmlName, 
		functionName, args, callbackFunction) {
		if (componentHtmlName !== 'Floorplan') return;

		if (angular.isFunction($scope[functionName])) {
			var returnValue = $scope[functionName].apply(this, args);
			if (angular.isFunction(callbackFunction)) callbackFunction(returnValue);
		} else {
			$log.warn('Could not find function ', functionName, ' in ', componentHtmlName, ' controller');
		}
	});
	
	$scope.$on('$destroy', function() {
		if ($scope.viewModel.refreshDataPromise) {
			$interval.cancel($scope.viewModel.refreshDataPromise);
		}
	});
	
	onInit(fpData);
});
